// extracted by mini-css-extract-plugin
export default {"athletePRsFilterCard":"AthletePRs_athletePRsFilterCard__UcZxK"};